export const UPDATE_FEED_CONFIG = 'UPDATE_FEED_CONFIG';
export const GET_FEED_CONFIG = 'GET_FEED_CONFIG';
export const SET_FEED_CONFIG = 'SET_FEED_CONFIG';
export const GET_FEED_CONFIG_UNIQUE_CREATOR = 'GET_FEED_CONFIG_UNIQUE_CREATOR';
export const SET_FEED_CONFIG_UNIQUE_CREATOR = 'SET_FEED_CONFIG_UNIQUE_CREATOR';
export const GET_FEED_CONFIG_HISTORY = 'GET_FEED_CONFIG_HISTORY';
export const SET_FEED_CONFIG_HISTORY = 'SET_FEED_CONFIG_HISTORY';
export const SET_LOADING = 'SET_LOADING';
export const SET_CIRCUIT_BREAKER_CONFIG = 'SET_CIRCUIT_BREAKER_CONFIG';
export const GET_CIRCUIT_BREAKER_CONFIG = 'GET_CIRCUIT_BREAKER_CONFIG';
export const UPDATE_CIRCUIT_BREAKER_CONFIG = 'UPDATE_CIRCUIT_BREAKER_CONFIG';
